import React, {Fragment} from "react";
import { connect } from "react-redux";

import FeatureDescription from "../../../../visComponents/featureDescription";
import FeatureName from "../../../../visComponents/featureName";
import MaterialSpinner from "../../../../ui/materialSpinner";
import LookFeatureOptions from "../../../lookNavigation/lookMain/lookFeature/lookFeatureOptions";
import LookFeaturePairPrice from "../../../lookNavigation/lookMain/lookListFeature/lookFeaturePairPrice";
import GroheFeatureQuantity from "./groheFeatureQuantity";
import GroheFeatureSQFTButton from "./groheFeatureSQFTButton";
import {isInStock} from "../../../lookNavigation/lookFunctions2";
import GroheFeatureSoldOut from "./groheFeatureSoldOut";
import GroheFeatureMoreInfoButton from "./groheFeatureMoreInfoButton";
import LookFeatureRemoveButton from "../../../lookNavigation/lookMain/lookFeatureRemoveButton";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import GroheFeatureLockedBadge from "./groheFeatureLockedBadge";
import GroheFeatureOptions from "./groheFeatureOptions";
import LookFeatureSku from "../../../lookNavigation/lookMain/lookFeature/lookFeatureSku";
import GroheFeatureNotInVisualizer from "./groheFeatureNotInVisualizer";

const GroheFeatureContent = (props) => {

  const {lookActiveFeature, selection} = props;

  if (!lookActiveFeature) {
    if (selection) {
      return <MaterialSpinner/>
    }
    return null
  }

  const disabled = !isInStock(lookActiveFeature);
  const showPriceLocked = getFeatureIsLocked(lookActiveFeature);

  return (
    <div className="lm-feature__content">
      {showPriceLocked ? (
        <GroheFeatureLockedBadge/>
      ) : (
        <Fragment>
          <div className="lk-title">
            <h2 className="lk-title__text"><FeatureName feature={lookActiveFeature} useCollectionName={true}/></h2>
          </div>
          <p className="lm-feature__content-model">
            <LookFeatureSku lookFeature={lookActiveFeature}/>
          </p>
          <div className="lm-feature__content-description">
            <FeatureDescription feature={lookActiveFeature} brief={true}/>
          </div>
          <div className="lk-feature__price">
            <LookFeaturePairPrice lookFeature={lookActiveFeature}/>
            <GroheFeatureMoreInfoButton/>
          </div>
        </Fragment>
      )}
      <div className="lk-feature__checkbox">
        {lookActiveFeature.notAvailableInVisualizer
          ? <GroheFeatureNotInVisualizer/>
          : <LookFeatureRemoveButton lookFeature={lookActiveFeature} isToggle={true}/>}
      </div>
      <GroheFeatureSoldOut disabled={disabled}/>
      <GroheFeatureOptions/>
      <LookFeatureOptions/>
      <div className="lk-feature__calculate">
        <GroheFeatureQuantity disabled={disabled || showPriceLocked}/>
        <GroheFeatureSQFTButton featureOpened={lookActiveFeature} isIcon={true} className="look-icon--ml-12" />
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, moreInfoOpened, moreInfoContent, lookActiveCategory} = store.lookState;
  const {isMobile, activeTheme} = store.serverState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    lookActiveFeature,
    moreInfoOpened,
    moreInfoContent,
    lookActiveCategory,
    isMobile,
    activeTheme,
    isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheFeatureContent)
